import { Link, useLocation } from "react-router-dom";
import LegalNav from "./LegalNav.jsx";
import Typo from "./LegalTypography.jsx";

export default function TermsPage() {
  const isMobile =
    new URLSearchParams(useLocation().search).get("viewmode") === "mobile";
  return (
    <div className="min-h-screen bg-white">
      <LegalNav />
      <main
        className={`max-w-[944px] mx-auto px-5 ${isMobile ? "" : "pt-[52px]"}`}
      >
        <div className="pt-14 pb-20">
          <Typo variant="h1">
            Điều khoản sử dụng Nebula
          </Typo>

          <Typo variant="p">
            Bằng việc truy cập, kích hoạt hoặc sử dụng Nebula, bao gồm nhưng
            không giới hạn ở AI chat, AI Agents, Nebula Ultra,… trên nền tảng
            Nebula (web và ứng dụng di động) bạn ("Người dùng") xác nhận đã đọc,
            hiểu và hoàn toàn đồng ý bị ràng buộc bởi các điều khoản và điều
            kiện dưới đây.
          </Typo>
          <Typo variant="p">
            Điều khoản sử dụng này bao gồm các điều khoản nêu tại đây cùng các
            thông tin quy định tại:{" "}
            <Link
              to="/privacy"
              className="font-semibold text-[#1a1a1a] hover:underline"
            >
              Chính sách bảo mật
            </Link>
            .
          </Typo>
          <Typo variant="p" mb="mb-8">
            Nếu bạn không đồng ý với bất kỳ điều khoản nào, vui lòng không sử
            dụng Nebula.
          </Typo>

          {/* Điều 1 */}
          <Typo variant="h2">Điều 1. Sản phẩm cung cấp</Typo>
          <Typo variant="p">
            Nebula cung cấp các công cụ hỗ trợ tham khảo. Đây là tính năng công
            nghệ được phát triển bởi Simplize, sử dụng các thuật toán và mô hình
            phân tích dữ liệu để cung cấp thông tin và công cụ tham khảo.
            Simplize là một công ty công nghệ, không phải là một công ty quản lý
            quỹ, công ty chứng khoán, hay một đơn vị tư vấn đầu tư chứng khoán.
            Mọi thông tin do Nebula tạo ra CHỈ MANG TÍNH CHẤT THAM KHẢO, không
            cấu thành một lời khuyên đầu tư, lời mời chào mua/bán tài sản tài
            chính nào, hay bất kỳ sự đảm bảo nào về lợi nhuận.
          </Typo>

          {/* Điều 2 */}
          <Typo variant="h2">Điều 2. Cảnh báo rủi ro cấp độ cao</Typo>
          <Typo variant="p">
            2.1. Đầu tư chứng khoán luôn tiềm ẩn rủi ro đáng kể, bao gồm nguy cơ
            mất một phần hoặc toàn bộ số vốn đầu tư. Thị trường tài chính chịu
            ảnh hưởng bởi nhiều yếu tố bất định và có thể biến động mạnh mà các
            mô hình AI không thể dự báo trước.
          </Typo>
          <Typo variant="p">
            2.2. Lợi nhuận trong quá khứ hoặc kết quả phân tích lại (backtest)
            của mô hình AI không đảm bảo cho hiệu suất trong tương lai.
          </Typo>
          <Typo variant="p">
            2.3. Người dùng phải nhận thức rằng Nebula gồm các công cụ tự động
            dựa trên Trí tuệ nhân tạo, có thể tạo ra những thông tin không chính
            xác, thiếu sót hoặc lỗi thời. Dữ liệu có thể bị trễ hoặc sai lệch so
            với thời gian thực.
          </Typo>
          <Typo variant="p">
            2.4. NGƯỜI DÙNG HOÀN TOÀN VÀ DUY NHẤT CHỊU TRÁCH NHIỆM cho tất cả
            các quyết định đầu tư và giao dịch của mình, bất kể quyết định đó có
            dựa trên việc sử dụng Nebula hay không.
          </Typo>

          {/* Điều 3 */}
          <Typo variant="h2">Điều 3. Tuyên bố miễn trừ trách nhiệm</Typo>
          <Typo variant="p">
            3.1. Simplize, bao gồm các giám đốc, nhân viên, cổ đông và đối tác,
            sẽ KHÔNG CHỊU TRÁCH NHIỆM PHÁP LÝ DƯỚI BẤT KỲ HÌNH THỨC NÀO đối với
            bất kỳ khoản thiệt hại (dù là trực tiếp, gián tiếp, ngẫu nhiên hay
            mang tính hệ quả) phát sinh từ:
          </Typo>
          <Typo variant="ul">
            <Typo variant="li">
              Việc Người dùng sử dụng hay không sử dụng thông tin Nebula cung
              cấp.
            </Typo>
            <Typo variant="li">
              Bất kỳ sự thiếu chính xác, không đầy đủ, lỗi thời hoặc sai sót nào
              trong dữ liệu, thông tin, hoặc kế hoạch gợi ý do Nebula cung cấp.
            </Typo>
            <Typo variant="li">
              Bất kỳ lỗi kỹ thuật, sự gián đoạn, hoặc việc tạm ngừng hoạt động
              của tính năng Nebula.
            </Typo>
          </Typo>
          <Typo variant="p">
            3.2. Nebula được cung cấp trên cơ sở "nguyên trạng" và "sẵn có".
            Simplize không đưa ra bất kỳ cam kết hay bảo đảm nào, dù là rõ ràng
            hay ngụ ý, về tính chính xác, độ tin cậy, sự phù hợp cho một mục
            đích cụ thể, hay khả năng hoạt động liên tục, không có lỗi của
            Nebula.
          </Typo>

          {/* Điều 4 */}
          <Typo variant="h2">Điều 4. Trách nhiệm của người dùng</Typo>
          <Typo variant="p">
            4.1. Người dùng có trách nhiệm tự mình tìm hiểu, phân tích và đánh
            giá lại các thông tin, kế hoạch gợi ý trước khi đưa ra bất kỳ quyết
            định đầu tư nào.
          </Typo>
          <Typo variant="p">
            4.2. Người dùng đồng ý sẽ không khiếu nại, khiếu kiện hoặc yêu cầu
            Simplize bồi thường cho bất kỳ khoản thua lỗ đầu tư nào liên quan
            đến việc sử dụng Nebula.
          </Typo>
          <Typo variant="p">
            4.3. Người dùng đồng ý cho phép Simplize sử dụng các thông tin dữ
            liệu được thu thập từ câu trả lời, các tham số được người dùng nhập
            vào khi sử dụng Nebula và dữ liệu từ tài khoản chứng khoán (khi được
            đồng ý chia sẻ), nhằm tạo Nebula cá nhân. Simplize cam kết đảm bảo
            an toàn bảo mật thông tin cá nhân của người dùng và không cung cấp
            thông tin cho bất kỳ bên thứ ba nào, trừ trường hợp phải cung cấp
            theo yêu cầu của pháp luật.
          </Typo>

          {/* Điều 5 */}
          <Typo variant="h2">Điều 5. Giới hạn trách nhiệm pháp lý</Typo>
          <Typo variant="p">
            Trong trường hợp bất kỳ điều khoản miễn trừ trách nhiệm nào trong
            thỏa thuận này bị tòa án có thẩm quyền tuyên bố là vô hiệu, và
            Simplize phải chịu trách nhiệm pháp lý, thì tổng trách nhiệm bồi
            thường tối đa của Simplize đối với Người dùng cho mọi thiệt hại, tổn
            thất và nguyên nhân khởi kiện sẽ không vượt quá tổng số tiền phí
            dịch vụ mà Người dùng đã thanh toán cho Simplize để sử dụng Nebula
            trong vòng 01 (một) tháng liền kề trước ngày phát sinh sự kiện gây
            ra khiếu nại.
          </Typo>

          {/* Điều 6 */}
          <Typo variant="h2">Điều 6. Quyền sở hữu trí tuệ</Typo>
          <Typo variant="p">
            Toàn bộ thuật toán, mã nguồn, giao diện, thiết kế, dữ liệu và các
            thành phần khác của Nebula là tài sản trí tuệ độc quyền của
            Simplize. Người dùng không được phép sao chép, chỉnh sửa, phân phối
            lại, dịch ngược (reserse engineering), trích xuất dữ liệu (scraping)
            hay cố gắng truy cập vào mã nguồn của Nebula.
          </Typo>

          {/* Điều 7 */}
          <Typo variant="h2">Điều 7. Quy tắc ứng xử khi sử dụng Nebula</Typo>
          <Typo variant="p">Bạn đồng ý không sử dụng tính năng AI chat để:</Typo>
          <Typo variant="ul">
            <Typo variant="li">
              Đưa vào các thông tin bất hợp pháp, lừa đảo, hoặc vi phạm thuần
              phong mỹ tục.
            </Typo>
            <Typo variant="li">
              Tìm cách bẻ khóa (jail break) hoặc thao túng các mô hình AI của
              Nebula.
            </Typo>
            <Typo variant="li">
              Gửi lệnh spam hoặc làm quá tải hệ thống API của Nebula.
            </Typo>
          </Typo>

          {/* Điều 8 */}
          <Typo variant="h2">Điều 8. Thay đổi điều khoản và chấm dứt dịch vụ</Typo>
          <Typo variant="p">
            Simplize có quyền sửa đổi, bổ sung các điều khoản này vào bất kỳ lúc
            nào. Mọi thay đổi sẽ được cập nhật trên website của Simplize và
            chúng tôi sẽ cố gắng thông báo đến Người dùng. Việc Người dùng tiếp
            tục sử dụng tính năng sau khi thay đổi có hiệu lực đồng nghĩa với
            việc chấp nhận các điều khoản mới. Simplize cũng có quyền tạm ngừng
            hoặc chấm dứt cung cấp tính năng Nebula mà không cần báo trước.
          </Typo>

          {/* Điều 9 */}
          <Typo variant="h2">
            Điều 9. Quy định về Gói hội viên, Thanh toán và Bàn giao
          </Typo>

          <Typo variant="h3">9.1. Đăng ký và Quy định sử dụng tài khoản Hội viên</Typo>
          <Typo variant="p">
            Người dùng có thể đăng ký sử dụng Nebula thông qua việc đăng ký gói
            hội viên hoặc mua credit. Giá sẽ được niêm yết công khai trên ứng
            dụng hoặc trang web Nebula.
          </Typo>
          <Typo variant="p">
            Trong mọi trường hợp, Người dùng không được phép chia sẻ thông tin
            đăng nhập và mật khẩu của mình với người khác, hoặc chia sẻ lại nội
            dung của Nebula dưới bất kỳ hình thức nào. Nebula có thể theo dõi
            địa chỉ IP để xác định việc sử dụng nội dung sai mục đích và vi phạm
            điều khoản chính sách của Nebula. Chúng tôi có thể thực hiện các
            biện pháp giới hạn số lượng thiết bị truy cập website/app Nebula.
            Nebula có quyền hủy đăng ký thành viên của Người dùng nếu phát hiện
            tài khoản thành viên được truy cập bởi một bên thứ ba không phải là
            Người dùng.
          </Typo>

          <Typo variant="h3">9.2. Phương thức thanh toán và Ủy quyền thanh toán</Typo>
          <Typo variant="p">
            Nebula chấp nhận các phương thức thanh toán trực tuyến phổ biến được
            tích hợp sẵn trên Website/App. Người dùng đồng ý ủy quyền cho Nebula
            thực hiện tự động trích nợ thẻ Tín dụng cho khoản phí hội viên ban
            đầu và các khoản phí hội viên định kỳ theo Gói hội viên được đăng
            ký, cho đến khi Người dùng hủy đăng ký.
          </Typo>

          <Typo variant="h3">9.3. Xác nhận và Bàn giao</Typo>
          <Typo variant="p">
            Do Nebula cung cấp Gói phần mềm trực tuyến, không có sản phẩm vật
            lý, việc bàn giao Gói phần mềm được thực hiện thông qua việc kích
            hoạt quyền truy cập tài khoản cho khách hàng ngay sau khi thanh toán
            thành công. Không áp dụng các chính sách về vận chuyển và giao nhận
            vật lý.
          </Typo>

          <Typo variant="h3">9.4. Chính sách hủy và hoàn tiền</Typo>
          <Typo variant="p">
            Người dùng có quyền hủy đăng ký sử dụng Nebula bất cứ lúc nào. Chúng
            tôi không có chính sách hoàn tiền cho Người dùng đã đăng ký gói hội
            viên hoặc mua credit. Credit không có giá trị quy đổi thành tiền mặt
            trong mọi trường hợp.
          </Typo>

          {/* Điều 10 */}
          <Typo variant="h2">Điều 10. Luật áp dụng và giải quyết tranh chấp</Typo>
          <Typo variant="p">
            Các điều khoản này được điều chỉnh và giải thích theo pháp luật của
            nước Cộng hòa Xã hội Chủ nghĩa Việt Nam. Mọi tranh chấp phát sinh sẽ
            được ưu tiên giải quyết thông qua thương lượng, hòa giải. Nếu không
            thể giải quyết, tranh chấp sẽ được đưa ra giải quyết tại Tòa án nhân
            dân có thẩm quyền tại Thành phố Hà Nội.
          </Typo>

          {/* Liên hệ */}
          <Typo variant="h2">Liên hệ</Typo>
          <Typo variant="p">Mọi thắc mắc về Điều khoản này, vui lòng liên hệ:</Typo>
          <Typo variant="p" mb="">
            <Typo variant="strong">Email:</Typo>{" "}
            <a
              href="mailto:info@simplize.vn"
              className="text-[#006CEC] hover:underline"
            >
              info@simplize.vn
            </a>
          </Typo>
        </div>
      </main>
    </div>
  );
}
